import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MAIN_CONTENT_ID } from '@core/app/app.constants';


/**
 * Skip link — lets keyboard users bypass repeated layout regions (header, sidebar)
 * and jump straight to the page content.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-skip-link',
    templateUrl: './skip-link.component.html',
    styleUrl: './skip-link.component.scss',
    imports: [TranslatePipe],
})
export class SkipLinkComponent {
    /**
     * ID of the element to focus and scroll to
     */
    @Input() public targetId: string = MAIN_CONTENT_ID;

    readonly #document: Document = inject(DOCUMENT);

    public skipToContent(event: Event): void {
        event.preventDefault();
        this.#document.querySelector<HTMLElement>(`#${this.targetId}`)?.focus();
    }
}
